(() => {
  const angular = window.angular;

  angular.module('app').config(Router);

  Router.$inject = ['$stateProvider'];

  function Router($stateProvider) {
    $stateProvider.state('member.var.show.customer.show.project.countReport', {
      url: '/bi/',
      template: `<new-front-container path="'count-report'"></new-front-container>`,
      authenticated: true,
      ncyBreadcrumb: {
        label: '{{"entities.tool.__tools.CountReport" | translate}}',
      },
    });
  }
})();
